












import { Prop, Vue, Watch } from 'vue-property-decorator'
import Component from 'vue-class-component'
import Hot from '@/services/hot/Hot'
import HotService from '@/services/HotService'
import { NotifyHelper } from 'vue-kit'
import PriceConfig from '@/dto/price_config/PriceConfig'
import priceConfigStore from '@/stores/PriceConfigStore'
import PriceConfigService from '@/services/PriceConfigService'
import PriceConfigItem from '@/dto/price_config/PriceConfigItem'
import PriceConfigItemsHeader from '@/components/price-config/PriceConfigItemsHeader.vue'
import layoutStore from '@/stores/LayoutStore'

const hot = new Hot()
@Component({
  components: { PriceConfigItemsHeader },
})
export default class PriceConfigItems extends Vue {
  @Prop(Object)
  model: PriceConfig

  priceConfigStore = priceConfigStore
  layoutStore = layoutStore
  isPending: boolean = false
  priceConfigItems: PriceConfigItem[] = []

  mounted() {
    this.initHot()
  }

  initHot() {
    const viewConfig = HotService.getPriceConfigSetting({
      currencyCode: this.model.currencyCode as string,
    })

    hot.init(this.$refs.mountPoint as Element, viewConfig)
    hot.loadData(this.priceConfigItems)
  }

  rerenderHot() {
    hot.hotInstance.destroy()
    this.initHot()
    hot.loadData(hot.editData)
    hot.hotInstance.updateSettings({ minSpareRows: 1 })
  }

  saveChanges() {
    const changedItems = this.getChangedItems()

    if (!changedItems.length) {
      return
    }

    this.isPending = true

    PriceConfigService.savePriceConfigItems(
      this.model.id as number,
      changedItems
    )
      .then(items => {
        this.priceConfigItems = items
        NotifyHelper.success('Успешное сохранение')
      })
      .catch(() => NotifyHelper.error('Ошибка сервера'))
      .finally(() => (this.isPending = false))
  }

  cancelChanges() {
    hot.loadData([...this.priceConfigItems])
    hot.hotInstance.updateSettings({ minSpareRows: 1 })
    hot.changes = []
  }

  getChangedItems(): PriceConfigItem[] {
    const changes = hot.getChanges()
    const changedRows = new Set(changes.map(change => change.rowIndex))

    return hot.viewData.filter((row, index) => changedRows.has(index))
  }

  @Watch('model', { immediate: true })
  loadPriceConfigItems() {
    this.isPending = true

    PriceConfigService.getPriceConfigItems(this.model.id as number)
      .then(items => (this.priceConfigItems = items))
      .finally(() => (this.isPending = false))
  }

  @Watch('model.weightMeasureUnit')
  updateCurrencyLabel(currencyCode: string) {
    hot.hotInstance.updateSettings(
      HotService.getPriceConfigSetting({
        currencyCode,
      }) as any
    )
  }

  @Watch('priceConfigItems')
  setHotData(priceConfigItems: PriceConfigItem[]) {
    hot.loadData(priceConfigItems)
    hot.hotInstance.updateSettings({ minSpareRows: 1 })
    hot.changes = []
  }

  @Watch('layoutStore.isShowLeftSidebar')
  rerenderTable(value: boolean | number) {
    if (typeof value === 'boolean') {
      setTimeout(() => {
        this.rerenderHot()
      }, 500)
    } else {
      this.rerenderHot()
    }
  }
}
